/**
 * BarData entry point — initializes the singleton service and registers
 * the default sources. Import this module ONCE on app boot to wire everything.
 */

import { barDataService } from './BarDataService';
import { LocalCSVBarSource } from './sources/LocalCSVBarSource';
import { NinjaTraderBarSource } from './sources/NinjaTraderBarSource';

let initialized = false;

/**
 * Idempotent initialization. Safe to call multiple times — repeat calls
 * are no-ops. Sources are registered by ascending priority — NT bars first
 * (priority 50, authoritative), LocalCSV last (priority 1000, universal
 * fallback). The service walks them in priority order and uses the first
 * one that returns data.
 */
export const initBarData = () => {
  if (initialized) return barDataService;
  barDataService.register(new NinjaTraderBarSource());
  barDataService.register(new LocalCSVBarSource());
  initialized = true;
  return barDataService;
};

export { barDataService } from './BarDataService';
export { LocalCSVBarSource } from './sources/LocalCSVBarSource';
export { NinjaTraderBarSource } from './sources/NinjaTraderBarSource';
export { parseCsvToBars } from './csvBarParser';
